/**
 * KRUX Launch Controller
 * ────────────────────────────────────────────────────────────────────
 * Launch:              August 18 2026 at 18:00 AEST (= 08:00 UTC)
 * Founding Crew Early: August 16 2026 at 18:00 AEST (= 08:00 UTC)
 *
 * Body classes applied synchronously in <head> (see krux-hero.liquid).
 * This script drives countdowns and auto-unlock logic.
 */

(function () {
  'use strict';

  /* ── Timestamps ──────────────────────────────────────────────────── */
  var LAUNCH_MS      = Date.UTC(2026, 7, 18, 8, 0, 0); // Aug 18 18:00 AEST
  var CREW_UNLOCK_MS = Date.UTC(2026, 7, 16, 8, 0, 0); // Aug 16 18:00 AEST

  /* ── Founding Crew early-access detection ─────────────────────────
   * Email link includes ?fc_access=1 — stored in sessionStorage so it
   * persists while the visitor browses the site in the same session.  */
  var FC_KEY = 'krux_fc_access';
  (function detectFC() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('fc_access')) sessionStorage.setItem(FC_KEY, '1');
    } catch (e) {}
  })();

  function hasFCAccess() {
    try { return sessionStorage.getItem(FC_KEY) === '1'; } catch (e) { return false; }
  }

  /* ── Current state ────────────────────────────────────────────────  */
  function getState() {
    var now = Date.now();
    if (now >= LAUNCH_MS)     return 'launched';
    if (now >= CREW_UNLOCK_MS && hasFCAccess()) return 'crew';
    return 'prelaunch';
  }

  /* ── Apply body class (idempotent, safe to call multiple times) ─── */
  function applyBodyClass(state) {
    var body = document.body || document.documentElement;
    body.classList.remove('krux-prelaunch', 'krux-crew-window', 'krux-launched');
    if (state === 'launched')  body.classList.add('krux-launched');
    else if (state === 'crew') body.classList.add('krux-crew-window');
    else                       body.classList.add('krux-prelaunch');
  }

  var state = getState();
  applyBodyClass(state);

  /* ── Helpers ─────────────────────────────────────────────────────── */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function msToparts(ms) {
    if (ms <= 0) return { d: '00', h: '00', m: '00', s: '00' };
    var t  = Math.floor(ms / 1000);
    return {
      d: pad(Math.floor(t / 86400)),
      h: pad(Math.floor((t % 86400) / 3600)),
      m: pad(Math.floor((t % 3600) / 60)),
      s: pad(t % 60)
    };
  }

  function updateEl(el, attr, val) {
    var n = el.querySelector('[' + attr + ']');
    if (n) n.textContent = val;
  }

  function updateCountdown(root, parts) {
    updateEl(root, 'data-cd-days', parts.d);
    updateEl(root, 'data-cd-hours', parts.h);
    updateEl(root, 'data-cd-mins',  parts.m);
    updateEl(root, 'data-cd-secs',  parts.s);
  }

  /* ── Launch handler ──────────────────────────────────────────────── */
  function handleLaunch() {
    state = 'launched';
    applyBodyClass('launched');

    // Remove all countdown banners
    document.querySelectorAll('[data-countdown-banner]').forEach(function (el) { el.remove(); });

    // Re-enable any disabled cart buttons
    document.querySelectorAll('[data-atc-locked]').forEach(function (btn) {
      btn.disabled = false;
      btn.removeAttribute('data-atc-locked');
    });

    // Fire a custom event for any other scripts listening
    try { document.dispatchEvent(new CustomEvent('krux:launched')); } catch (e) {}

    clearInterval(timerID);
  }

  /* ── Tick ────────────────────────────────────────────────────────── */
  var timerID;

  function tick() {
    var now    = Date.now();
    var msLeft = LAUNCH_MS - now;

    if (msLeft <= 0) { handleLaunch(); return; }

    var parts = msToparts(msLeft);

    // Card banners
    document.querySelectorAll('[data-countdown-banner]').forEach(function (el) {
      updateCountdown(el, parts);
    });

    // Hero countdown
    var heroCD = document.getElementById('krux-hero-countdown');
    if (heroCD) updateCountdown(heroCD, parts);
  }

  /* ── NOTIFY ME buttons — open popup ─────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-notify-me]');
    if (!btn) return;
    e.preventDefault();
    // Trigger the popup
    var popup = document.getElementById('krux-popup');
    if (popup) {
      popup.dispatchEvent(new CustomEvent('krux:open-popup', { bubbles: false }));
    }
  });

  /* ── Init ────────────────────────────────────────────────────────── */
  if (state !== 'launched') {
    tick(); // immediate first tick
    timerID = setInterval(tick, 1000);
  }

  /* ── Public API ──────────────────────────────────────────────────── */
  window.KruxLaunch = {
    LAUNCH_MS:     LAUNCH_MS,
    CREW_UNLOCK_MS: CREW_UNLOCK_MS,
    isLaunched:    function () { return Date.now() >= LAUNCH_MS; },
    hasFCAccess:   hasFCAccess,
    getState:      getState
  };

})();
